export const engines = {
  node: '>=20.0.0 <=24.x.x',
  npm: '>=6.0.0',
};
